<template>
  <div class="col-md-12">
    {{ getConfirmBoxResponse }}
    <div class="row rt-menu-100">
      <div class="col-md-12 pl-0 mart-10">
        <div v-if="isAbhaEnabled && documents && documents.length" class="col-md-12 pr-0 uploaded-images">
          <label class="label">ABHA Health Records</label>
          <div class="images-box">
            <div class="image-head">
              <div class="row">
                <div class="col-lg-5 full-left visit-secton"><strong>Document</strong></div>
                <div class="col-lg-4"><strong>Date</strong></div>
                <div class="col-lg-3"><strong>Action</strong></div>
              </div>
            </div>
            <div class="image-list-name" v-for="(doc, idx) in documents" :key="idx">
              <div class="row">
                <div class="col-lg-5">{{ doc.fileName.substring(doc.fileName.indexOf('_') + 1) || 'Health Document' }}</div>
                <div class="col-lg-4">{{ formatDate(doc.date || doc.document_date || doc.created_date) }}</div>
                <div class="col-lg-3">
                  <a href="#" @click.prevent="openFile(doc.s3Key)">View</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isAbhaEnabled && showspinner" class="col-md-12 text-center">
          <span>Loading health records...</span>
        </div>
        <div v-if="ImageUploadedlist && ImageUploadedlist.length" class="col-md-12 pr-0 uploaded-images">
          <label class="label">{{ $t('UploadHistory') }}</label>
          <div class="row" v-for="item in ImageUploadedlist">
            <div class="col-md-12">
              <div class="images-box">
                <div class="image-head">
                  <div class="row">
                    <div class="col-lg-3 full-left visit-secton">
                      <strong>File</strong>
                    </div>
                    <div class="col-lg-2 full-left visit-secton">
                      <strong>Visit ID</strong>
                      <!-- {{ it.patient_encounter_number }} -->
                    </div>
                    <div class="col-lg-2">
                      <strong> Visit date</strong>
                    </div>
                    <div class="col-lg-2">
                      <strong> Uploaded date </strong>
                    </div>
                    <div class="col-lg-2">
                      <strong> Uploaded time </strong>
                    </div>
                    <!-- <div class="col-lg-1">
                                            <strong> Action </strong>
                                          </div>                                           -->
                  </div>
                </div>
                <div class="image-list-name" v-for="it, index in item.values">
                  <div class="row">
                    <div class="col-lg-3">
                      <a @click.prevent="
                        viewFile(
                          it.report_file_key,
                          'file'
                        )
                        " :href="getdownloadfileUrl"
                        :style="!(it.image_name && it.image_name.indexOf('pdf') == -1) ? 'padding:11px;' : ''">
                        <span v-if="it.image_name && it.image_name.indexOf('pdf') == -1">
                          <img :src="it.imageUrl">
                        </span>
                        <span v-else class="media-left docupld-icon"></span>
                      </a>
                      <a class="image-name " @click.prevent="
                        viewFile(
                          it.report_file_key,
                          'file'
                        )
                        " :href="getdownloadfileUrl">{{ it.image_name }}
                      </a>
                    </div>
                    <div class="col-lg-2" v-if="item.key">
                      {{ item.key }}
                    </div>
                    <div class="col-lg-2" v-else>
                      N/A
                    </div>
                    <div class="col-lg-2">
                      <span></span>
                      {{ it.visit_date }}
                    </div>
                    <div class="col-lg-2">
                      <span></span>
                      {{ formatTime(it.uploaded_date, false) }}
                    </div>
                    <div class="col-lg-2 image-date">
                      <span class="time-field"></span> {{ formatTime(it.uploaded_date, true) }}
                    </div>

                    <!-- <div class="col-lg-1 pull-right align-self-start" >
                                                 <a href="#"
                                            style="color:#4f5051 !important;"
                                            class="pull-right"
                                            @click.prevent="deleteImage(it.unique_id,it.encounter_id,it.report_file_key)"
                                            ><i data-toggle="tooltip"
                                              data-original-title="Delete"
                                              class="material-icons delete-image"
                                              >delete</i> </a>
                                          </div> -->
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="col-md-12 pr-0 uploaded-images">
          <label class="label">{{ $t('UploadedFiles') }}</label>
          <div class="row">
            <div class="col-md-12">
              <div class="images-box center-text" style="text-align: center;">
                {{ $t('NoFileHasBeenUploaded') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>


<script>
import EhrImmunizationLeftMenu from "@/components/Navmenu/ehrImmunizationleftmenu.vue";
import CaseSheetLeftmenu from "@/components/HMS/CaseSheetLeftmenu.vue";
import EhrLeftNav from "@/components/Navmenu/ehrLeftmenu";
import LeftMenuPatientInfo from "@/components/Navmenu/LeftMenuPatientInfoehrlite";
import PatientPeronsaldet from "@/components/Navmenu/EHR-Lite/PatientPersonalDetails";
import PatientHistoryandReports from "@/components/Navmenu/EHR-Lite/PatientHistoryandReports";
import EHREncounterMenu from "@/components/Navmenu/EHREncounterMenu";
import EHRSubEncounterMenu from "@/components/Navmenu/EHRSubEncounterMenu";
import ehrrightmenu from "@/components/Navmenu/EHRRightMenu";
import ehrheader from "@/components/Headers/EHR_Header";
import EHRSubMenu from "@/components/Navmenu/EHRSubMenu";
import ViewEncounterdetails from "@/components/common/ViewEncounter";
import ImmunizationPopup from "@/components/Immunization/ImmunizationPopup";
import CreatePrescription from "@/components/Prescription/createprescription";
import InvoiceReceiptApi from '@/api/InvoiceReceipt.js';
import ConfirmBox from "@/components/MessagePopup/ConfirmPopup";
import ImageUploadAPI from "@/api/ImageUpload";
import Axios from "axios";
import Auth from "@/common/mixins";
import moment from "moment";
import rest_service from "@/api/rest_service";
import Messages from "@/components/MessagePopup/Messages";
import { mapActions, mapGetters, Store } from "vuex";

var immunizationlistUrl = rest_service.baseURL;
//EHRRightMenu Properties
var enccategoryid;
var isTemplateload;
var projectioncolumns = "";
var encounterstatus;
var encproviderid;
var cimsicd10codes = [];
export default {
  components: {
    EhrLeftNav,
    CaseSheetLeftmenu,
    LeftMenuPatientInfo,
    PatientPeronsaldet,
    PatientHistoryandReports,
    EHREncounterMenu,
    ehrheader,
    EHRSubMenu,
    ehrrightmenu,
    ViewEncounterdetails,
    ImmunizationPopup,
    EHRSubEncounterMenu,
    CreatePrescription,
    ConfirmBox,
    Messages,
    clinicalnoteSubMenu: () =>
      import("@/components/Navmenu/clinicalnoteSubMenu"),
    examplemodal: () => import("@/components/Investigation/InvestigationPopup"),
    ProbelmsIllness: () =>
      import("@/components/ProblemsIllness/ProblemsandIllness"),
    clinicalnotesNav: () => import("@/views/EHR/ComplaintsAndDiagnosis/clinicalnotesNav"),
  },

  data() {
    return {
      //health doc
      documents: [],
      showspinner: false,
      customerId: "",
      //
      parentuser: null,
      is_dutydoctor: false,
      caseshettmenu: false,
      prevRoute: null,
      isdisplaymsg: false,
      intake_output: false,
      sucessmsgtext: "",
      prevRoute: null,
      recordToDelete: "",
      encidtodelete: "",
      inpatienttocasesheet: false,
      getprescription: [],
      showprescriptionpopup: false,
      ViewPrecriptionData: {},
      cimsicd10codes,
      encounter: {},
      clinicalnotesurl: "",
      parentproperty: this,
      tenantId: "",
      userUniquetenantId: "",
      immunizationlist: [],
      deleted_plans: "",
      viewImmunizationData: {},
      ViewImmunizationData: {},
      oneditImmunizationdata: {},
      viewImmunizationPopupData: [],
      deleteitem: {},
      encounterID: "",
      moment: moment,
      showimmunizationpopup: false,
      //EHRRightMenu Properties
      enccategoryid,
      isTemplateload: false,
      projectioncolumns,
      encounterstatus,
      encproviderid,
      //view encounter
      isviewencounter: false,
      viewencrangekey: null,
      viewcategoryid: null,
      viewpatientid: null,
      viewproviderid: null,
      projectioncolumns: "",
      encounter: {},
      currentPage: 1,
      itemsPerPage: 10,
      resultCount: 0,
      immunizationpaginationArr: [],
      foreditimmunization: {},
      patientdetails: "",
      providerid: "",
      role_unique_id: "",
      authenticationToken: "",
      tenantId: "",
      encounterData: {},
      uploadedimages: [],
      imagesurl: [],
      filekey: "",
      getdownloadfileUrl: null,
      foldername: "",
      ImageUploadedlist: [],
      tempUploadedImages: [],
      encounterlist: [],
      encounterDataToUpdate: {},
      showCnfrmPopUp: false,
      confrmPopUpResponse: false,
      actionMsg: "",
      customheadertxt: "Confirm Action",
      imagesList: [],
      selectedItem: null,
      isSeniorDoctor: false,
      loggeedin_userinfo: "",
    };
  },
  created() {
    if (Auth.checkAuthentication()) {
      var loggedinuserinfo = JSON.parse(localStorage.loggedInUserInfo);
      if (loggedinuserinfo) {
        this.provider_id = loggedinuserinfo.unique_id;
        this.role_unique_id = loggedinuserinfo.role.unique_id;
      }
      if (localStorage.getItem("hmsinpatient") && localStorage.getItem("hmsinpatient") == 'true') {
        this.caseshettmenu = true;

      }
      if (localStorage.getItem("inpatientstatus") && localStorage.getItem("inpatientstatus") == 'true') {
        this.inpatienttocasesheet = true;
      }
      else {
        this.inpatienttocasesheet = false;
      }

      if (localStorage.getItem("intakeoutput") && localStorage.getItem("intakeoutput") == 'true') {
        this.intake_output = true;

      }
      if (localStorage.getItem("currentEncounterUrl")) {
        this.clinicalnotesurl = localStorage.getItem("currentEncounterUrl");
      }
      if (window.localStorage.getItem("accesstoken")) {
        this.authenticationToken = window.localStorage.getItem("accesstoken");
      }
      this.parentuser = JSON.parse(localStorage.getItem("loggedInUserInfo"));
      if (this.parentuser != null && this.parentuser.role) {
        this.role_unique_id = this.parentuser.role.unique_id;
      }
      if (this.role_unique_id == "afab81a3-0cc8-4c08-a303-efc2c4b361a8") {
        this.is_dutydoctor = true;
      }
      if (localStorage.getItem("tenantid")) {
        this.tenantId = localStorage.getItem("tenantid");
      }

      if (window.localStorage.getItem("loggedInUserInfo")) {
        this.loggeedin_userinfo = JSON.parse(window.localStorage.getItem("loggedInUserInfo"));
      }

      this.isSeniorDoctor = this.loggeedin_userinfo.role && this.loggeedin_userinfo.role.name === "Senior Doctor" && this.loggeedin_userinfo.role.unique_id === "b36cde87-00c0-4583-9986-ec8981186535";


      // this.getpatientDetails(this.$route.query.patient_id)
      //  this.getencdata();
      //this.getencounterlist();
      this.getImageslistbycustomer();
      if (this.isAbhaEnabled) {
        this.customerId = this.$route.query.patient_id;
        this.fetchDocuments();
      }
    }
  },

  computed: {
    getConfirmBoxResponse() {

      if (this.confrmPopUpResponse && !this.showCnfrmPopUp) {
        this.confirmDelete(this.recordToDelete, this.encidtodelete, this.selectedItem);
      }
      // else{
      //   this.confrmPopUpResponse = false;
      // }
    },
    isAbhaEnabled() {
      const tenantObj = JSON.parse(sessionStorage.getItem('tenantObj'));
      if (!tenantObj || !tenantObj.nhA_ABDM) return false;
      return tenantObj.nhA_ABDM;
    },
  },
  updated() {
    setTimeout(
      function () {
        this.closeMessage();
      }.bind(this),
      3000
    );

    var headerhold = document.getElementById("headerholds");
    var headerholdsmall = document.getElementById("headerholdsmalls");
    if (
      headerholdsmall &&
      headerholdsmall.classList.contains("header-logohide")
    ) {
      var nde = document.getElementById("menuhold");
      if (nde != null) {
        nde = nde.classList.remove("menuHold1");
      }
    } else if (headerhold && headerhold.classList.contains("header-logohide")) {
      var nde = document.getElementById("menuhold");
      if (nde != null) {
        nde = nde.classList.add("menuHold1");
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.fullPath;
    })
  },

  methods: {
    //for health documents
    getCommonHeadershealth() {
      return {
        Accept: "application/json, text/plain, */*",
        Authorization: this.authenticationToken,
        loggedin_user_unique_id: this.loggedin_user_unique_id,
        role_unique_id: this.role_unique_id,
        x_tenant_id: this.tenantId
      };
    },

    async fetchDocuments() {
      this.showspinner = true;
      try {
        const response = await Axios.get(
          `${rest_service.baseURL}/healthdocuments/list/${this.customerId}`,
          { headers: this.getCommonHeadershealth() }
        );
        if (response && response.data) {
          this.documents = response.data;
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      } finally {
        this.showspinner = false;
      }
    },
    //end health documents

    gotoclinicalnotes() {
      this.$router.push({ path: this.clinicalnotesurl })
    },
    backtoprevious(urlp) {
      // this.$router.push({
      //   path: this.prevRoute.fullPath
      // });  
      debugger;
      window.open(urlp, "_self");
    },
    getencounterlist() {
      var self = this;
      var masterdata = {
        customer_id: this.$route.query.patient_id,
        provider_id: this.provider_id
      };
      rest_service
        .get("/formrender/GetEncountersByCustomerprovider", this.tenantId, masterdata)
        .then(responce => {
          if (
            responce &&
            responce.data &&
            responce.data.result &&
            responce.data.result.length > 0
          ) {
            // for (let i = 0; i < responce.data.result.length; i++) {
            //   responce.data.result[i].created_date = moment(
            //     responce.data.result[i].created_date
            //   ).format("DD-MM-YYYY hh:mm A");
            // }
            self.encounterlist = responce.data.result;
          } else {
            self.encounterlist = [];
          }
        });
    },
    getImageslistbycustomer() {
      var self = this;
      var param = {
        patient_id: this.$route.query.patient_id,
        scanIndexForward: false
      }
      self.uploadedimages = [];

      ImageUploadAPI.getimagelistbycustomerid(param).then(function (response) {
        if (response != null && response != undefined) {
          self.imagesList = [];
          self.imagesList = response.result;
          var temp_images = [];
          self.imagesList.forEach(ele => {
            if (ele.hasOwnProperty("filelist")) {
              ele.filelist.forEach(y => {
                if (y.record_status === "undefined" || y.record_status === "null" || y.record_status !== false) {
                  let obj = {};
                  obj = y;
                  obj.patient_encounter_number = ele.patient_encounter_number;
                  obj.image_name = y.report_user_friendly_name;
                  obj.uploaded_date = moment(obj.uploaded_date);
                  obj.unique_id = ele.unique_id;
                  obj.customer_id = ele.customer_id;
                  obj.created_date = ele.created_date;
                  if (ele.visit_date && ele.visit_date != undefined && ele.visit_date != "undefined") {
                    obj.visit_date = moment(ele.visit_date).format("DD-MM-YYYY");
                  }
                  else {
                    obj.visit_date = "N/A";
                  }
                  if (ele.encounter_id && ele.encounter_id != undefined && ele.encounter_id != "undefined")
                    obj.encounter_id = ele.encounter_id;
                  //console.log(moment(obj.uploaded_date));
                  //self.uploadedimages.push(obj);
                  let parentuser = JSON.parse(localStorage.getItem("loggedInUserInfo"));
                  if (ele.provider_id == parentuser.unique_id) {
                    self.uploadedimages.push(obj);
                  }
                  if (self.isSeniorDoctor == true && ele.provider_id != parentuser.unique_id) {
                    self.uploadedimages.push(obj);
                  }
                }
              });
            }
            else {
              let obj = {};
              obj.patient_encounter_number = ele.patient_encounter_number;
              obj.image_name = ele.report_user_friendly_name;
              obj.uploaded_date = moment(ele.created_date);
              obj.report_file_key = ele.report_file_key;
              if (ele.encounter_id && ele.encounter_id != undefined && ele.encounter_id != "undefined")
                obj.encounter_id = ele.encounter_id;
              obj.unique_id = ele.unique_id;
              obj.customer_id = ele.customer_id;
              if (ele.visit_date && ele.visit_date != undefined && ele.visit_date != "undefined") {
                obj.visit_date = moment(ele.visit_date).format("DD-MM-YYYY");
              }
              else {
                obj.visit_date = "N/A";
              }
              let parentuser = JSON.parse(localStorage.getItem("loggedInUserInfo"));
              if (ele.provider_id == parentuser.unique_id) {
                self.uploadedimages.push(obj);
              }
              if (self.isSeniorDoctor == true && ele.provider_id != parentuser.unique_id) {
                self.uploadedimages.push(obj);
              }
              // self.uploadedimages.push(obj);
            }
            //this.getS3imageurl(this.foldername,obj);
          });
          self.uploadedimages = self.uploadedimages.sort((a, b) => moment(b.visit_date, "DD-MM-YYYY").diff(moment(a.visit_date, "DD-MM-YYYY")));

          self.getS3imageurl();
          return response;
        } else {
          return null;
        }
      });
    },
    getvisitdate(key) {
      var self = this;
      if (self.encounterlist) {
        self.encounterlist.forEach(element => {
          if (element.uploadedImageslist) {
            element.uploadedImageslist.forEach(ele => {
              if (key == ele.patient_encounter_number) {
                return moment(element.created_date).format("MM-DD-YYYY");
                console.log("DATE VALUE")
                console.log(element.created_date)
                // return element.created_date;

              }
            });
          }
        });
      }

    },
    getpatientdata() {
      this.patientDetails = JSON.parse(
        sessionStorage.getItem("encpatientdetails")
      );
      if (this.patientDetails && this.patientDetails.uploadedImageslist.length > 0) {
        var temp_images = [];
        this.patientDetails.uploadedImageslist.forEach(ele => {
          let obj = {};
          obj.patient_encounter_number = ele.patient_encounter_number;
          obj.image_name = ele.report_user_friendly_name;
          obj.uploaded_date = moment(ele.uploaded_date).format("DD-MM-YYYY hh:mm A");
          obj.report_file_key = ele.report_file_key;
          this.uploadedimages.push(obj);
          //this.getS3imageurl(this.foldername,obj);
        });
        //this.uploadedimages = Auth.groupBy(temp_images,'patient_encounter_number');

        console.log("<<<<UPLOADED IMAGES>>>>>");
        console.log(this.uploadedimages);
        //this.uploadedimages.push(obj);
        this.getS3imageurl();
      }
      else {
        this.ImageUploadedlist = [];
      }

    },
    deleteImage(unique_id, encid, itemid) {

      this.showCnfrmPopUp = false;
      this.confrmPopUpResponse = false;
      if (unique_id && itemid) {
        this.recordToDelete = unique_id;
        this.encidtodelete = encid;
        this.selectedItem = itemid;
        this.showCnfrmPopUp = true;
        this.actionMsg = "Are you sure you want to delete?";
      }
    },
    confirmDelete(unique_id, encid, itemid) {

      var self = this;
      if (this.imagesList.length) {
        this.imagesList.forEach(
          element => {
            if ((element.visit_date == "N/A" || element.visit_date == undefined) && (element.encounter_id == "undefined" || element.patient_encounter_number == undefined || element.encounter_id == undefined)) {
              if (element.unique_id == unique_id) {
                //   postdata.push(data);
                var config = {
                  method: 'delete',
                  url: rest_service.baseURL + "/imageupload/removestaffdocs",
                  headers: {
                    'Accept': "application/json, text/plain, */*",

                    'Authorization': localStorage.accesstoken,
                    'loggedin_user_unique_id': this.loggedin_user_unique_id,
                    'role_unique_id': this.role_unique_id,
                    'route_entity_name': '/HMS',
                    'x_tenant_id': localStorage.tenantid
                  },
                  params: {
                    unique_id: element.unique_id,
                    customer_id: element.customer_id,
                    itemid: itemid
                  },
                };
                var self = this;
                Axios(config)
                  .then(response => {
                    if (response && response.data) {
                      console.log("response>>>>>>>>>>>", response.data);
                      self.isdisplaymsg = true;
                      self.sucessmsgtext = "File deleted successfully";
                      self.confrmPopUpResponse = false;
                      self.getImageslistbycustomer();

                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              }
            }
            else {
              if (element.unique_id == unique_id) {
                if (element.filelist && element.filelist.length) {
                  element.filelist.forEach((x) => {
                    if (x.report_file_key === itemid && element.encounter_id === encid && unique_id === element.unique_id) {
                      var params = {
                        unique_id: element.unique_id,
                        customer_id: element.customer_id,
                        encounter_no: element.patient_encounter_number,
                        itemid: itemid
                      }
                      ImageUploadAPI.removeImages(params)
                        .then(categResponse => {
                          if (categResponse) {
                            self.isdisplaymsg = true;
                            self.sucessmsgtext = "File deleted successfully";
                            self.confrmPopUpResponse = false;
                            self.getImageslistbycustomer();
                          }
                        });
                    }
                  });
                }
                else {
                  if (element.report_file_key === itemid && element.encounter_id === encid && unique_id === element.unique_id) {
                    var params = {
                      unique_id: element.unique_id,
                      customer_id: element.customer_id,
                      encounter_no: element.patient_encounter_number,
                      itemid: element.report_file_key
                    }
                    ImageUploadAPI.removeImages(params)
                      .then(categResponse => {
                        if (categResponse) {
                          self.isdisplaymsg = true;
                          self.sucessmsgtext = "File deleted successfully";
                          self.confrmPopUpResponse = false;
                          self.getImageslistbycustomer();
                        }
                      });
                  }
                }
              }
            }

          });
      }
    },
    closeMessage() {
      this.isdisplaymsg = false;
    },
    getencdata() {
      var self = this;
      var masterdata = {
        range_key: this.$route.query.encounter_id
      };
      rest_service
        .get("/formrender/getformrenderbyid", this.tenantId, masterdata)
        .then(respo => {
          if (respo.data && respo.data.result) {
            this.encounterData = respo.data.result;
            if (sessionStorage.getItem("encounterdetails")) {
              sessionStorage.removeItem("encounterdetails")
              sessionStorage.setItem("encounterdetails", JSON.stringify(respo.data.result))
            }
            else {
              sessionStorage.setItem("encounterdetails", JSON.stringify(respo.data.result))
            }
          }
        });
    },
    getpatientDetails(patientid) {
      InvoiceReceiptApi.getehrPatient(patientid)
        .then(ehrpatient => {
          if (ehrpatient.data) {
            //self.ehrpatient = JSON.parse(ehrpatient.data.result);
            if (sessionStorage.getItem("encpatientdetails")) {
              sessionStorage.removeItem("encpatientdetails")
              sessionStorage.setItem("encpatientdetails", ehrpatient.data.result)
              this.patientDetails = JSON.parse(ehrpatient.data.result);
              if (this.patientDetails && this.patientDetails.uploadedImageslist) {
                var temp_images = [];
                this.patientDetails.uploadedImageslist.forEach(ele => {
                  let obj = {};
                  obj.patient_encounter_number = ele.patient_encounter_number;
                  obj.image_name = ele.report_user_friendly_name;
                  obj.uploaded_date = moment(ele.uploaded_date).format("DD-MM-YYYY hh:mm A");
                  obj.report_file_key = ele.report_file_key;
                  obj.encounter_id = ele.encounter_id;
                  obj.visit_date = moment(ele.visit_date).format("DD-MM-YYYY");
                  this.uploadedimages.push(obj);
                  //this.getS3imageurl(this.foldername,obj);
                });
                //this.uploadedimages = Auth.groupBy(temp_images,'patient_encounter_number');

                console.log("<<<<UPLOADED IMAGES>>>>>");
                console.log(this.uploadedimages);
                //this.uploadedimages.push(obj);
              }
              this.getS3imageurl();
              //this.getpatientdata();
            }
            else {
              sessionStorage.setItem("encpatientdetails", ehrpatient.data.result)
              this.patientDetails = ehrpatient.data.result;
              if (this.patientDetails && this.patientDetails.uploadedImageslist) {
                var temp_images = [];
                this.patientDetails.uploadedImageslist.forEach(ele => {
                  let obj = {};
                  obj.patient_encounter_number = ele.patient_encounter_number;
                  obj.image_name = ele.report_user_friendly_name;
                  obj.uploaded_date = moment(ele.uploaded_date).format("DD-MM-YYYY hh:mm A");
                  obj.report_file_key = ele.report_file_key;
                  this.uploadedimages.push(obj);
                  //this.getS3imageurl(this.foldername,obj);
                });
                //this.uploadedimages = Auth.groupBy(temp_images,'patient_encounter_number');

                console.log("<<<<UPLOADED IMAGES>>>>>");
                console.log(this.uploadedimages);
                //this.uploadedimages.push(obj);
              }
              this.getS3imageurl();
              //this.getpatientdata();
            }
          }
        })
    },
    formatTime: function (dtobj, onlyTime) {
      if (onlyTime) {
        return moment(dtobj).format("hh:mm A");
      }
      else {
        return moment(dtobj).format("DD-MM-YYYY");
      }
    },
    getS3imageurl() {
      var self = this;
      self.tempUploadedImages = [];
      self.ImageUploadedlist = [];
      self.uploadedimages.forEach(element => {
        var suburl = "/S3Proxy";
        var apiUrl = rest_service.baseURL + suburl + "/getfileurl";
        var fileKey = "";
        fileKey =
          self.tenantId +
          self.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath +
          element.report_file_key;
        return Axios.get(apiUrl, {
          headers: {
            x_tenant_id: this.tenantId,
            role_unique_id: this.role_unique_id,
            route_entity_name: suburl,
            loggedin_user_unique_id: this.provider_id,
            Authorization: this.authenticationToken,
            report_key: fileKey
          }
        })
          .then(function (response) {
            if (response != null && response.data != null) {
              let obj = {};
              obj.patient_encounter_number = element.patient_encounter_number;
              obj.image_name = element.image_name;
              obj.uploaded_date = element.uploaded_date;
              obj.report_file_key = element.report_file_key;
              obj.imageUrl = response.data.result;
              obj.encounter_id = element.encounter_id;
              obj.unique_id = element.unique_id;
              obj.customer_id = element.customer_id;
              obj.visit_date = element.visit_date;
              self.tempUploadedImages.push(obj);
            }
            else {
              return null;
            }
          })
          .catch(function (error) {
            return error;
          }).finally(() => {
            self.ImageUploadedlist = Auth.groupBy(self.tempUploadedImages, 'patient_encounter_number');
            // console.log("<<<<<IMAGE UPLOADED LIST>>>>>>");
            // console.log(self.ImageUploadedlist);
          });
      });
      //  self.ImageUploadedlist = Auth.groupBy(self.tempUploadedImages,'patient_encounter_number');
      //    console.log("<<<<<IMAGE UPLOADED LIST>>>>>>");
      //    console.log(self.ImageUploadedlist);
    },
    getimageurl() {
      if (this.uploadedimages) {
        this.uploadedimages.forEach(element => {
          //this.getUrlFromS3Bucket(this.tenantId + this.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath +element.report_file_key);
        });
      }
    },
    viewFile(itemKey, report_Type) {
      this.getdownloadfileUrl = null;
      if (typeof itemKey === "string" && itemKey && report_Type === "file") {
        this.foldername = this.tenantId + this.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath + itemKey;
      }
      //console.log("this.foldername>>>>viewFIle() ",this.foldername);
      //alert(this.foldername);
      //this.ac_getFromS3Bucket(this.foldername);
      this.viewItem = true;
      this.downLoadItem = false;
      // if (typeof item === "object" && itemtype === "webReport") {
      //   //alert(item.report_webUrl+"->"+item.report_webUrlUname+"->"+item.report_webUrlPass);
      //   this.reportWebsiteUrl = item.report_webUrl;
      //   this.reportWebsiteUname = item.report_webUrlUname;
      //   this.reportWebsitePass = item.report_webUrlPass;
      //   this.showWebReportModal = true;
      // }
      this.getUrlFromS3Bucket(this.foldername);
    },
    getUrlFromS3Bucket(fileKey) {
      var self = this;
      var suburl = "/S3Proxy";
      var apiUrl = rest_service.baseURL + suburl + "/getfileurl";
      return Axios.get(apiUrl, {
        headers: {
          x_tenant_id: this.tenantId,
          role_unique_id: this.role_unique_id,
          route_entity_name: suburl,
          loggedin_user_unique_id: this.provider_id,
          Authorization: this.authenticationToken,
          report_key: fileKey
        }
      })
        .then(function (response) {
          if (response != null && response.data != null) {
            self.getdownloadfileUrl = response.data.result;
            //console.log("REPORT VIEW URL>>>>>",self.getdownloadfileUrl);
            window.open(self.getdownloadfileUrl, "_blank", "channelmode=1");
          } else {
            return null;
          }
        })
        .catch(function (error) {
          return error;
        });
    },
    async openFile(key) {
      const url = await this.getPresignedUrl(key);
      window.open(url, "_blank");
    },

    async getPresignedUrl(key) {
      const response = await Axios.get(
        `${rest_service.baseURL}/healthdocuments/presigned-url`,
        {
          params: { key },
          headers: this.getCommonHeadershealth(),
        }
      );
      return response.data;
    },
    formatDate(dt) {
      return moment(dt).format("DD-MM-YYYY hh:mm A");
    },
    goToEncounter(urlp) {
      window.open(urlp, "_self");
    }
  }
};
</script>


<style>
.uploaded-images .label {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
}

.uploaded-images .images-box {
  border: 1px solid #c9cbce;
  min-height: 120px;
  /* max-height: 210px;*/
  margin-bottom: 20px;
  background-size: cover;
}

.uploaded-images .images-box .image-head {
  background: #efefef;
  padding: 15px;
}

.uploaded-images .images-box .image-list-name {
  padding: 10px 15px;
  border-bottom: 1px solid #ededed;
}

.image-list-name .col-lg-5,
.image-list-name .col-lg-2,
.image-list-name .col-lg-3,
.image-list-name .col-lg-1 {
  display: flex;
  align-items: center;
  height: 50px;
}

.uploaded-images .images-box p {
  color: #000;
}

.uploaded-images .images-box a {
  cursor: pointer;
  color: #0056e1 !important;
  font-weight: 600;
}

a.image-name {
  overflow: hidden;
  display: inline-block;
  max-width: 92%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.uploaded-images .images-box img {
  border-radius: 50%;
  height: 50px;
  min-width: 50px;
  max-width: 50px;
  margin-right: 10px;
}

.images-box a {
  word-break: break-word;
}
</style>

<style scoped>
.center-text{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
